function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Rollover-Call-Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.2.-Rollover-Call-Dashboard",
  transform: "translate(-352.000000, -248.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(64.000000, 244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "place_black_24dp",
  transform: "translate(288.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16 0 16 16 0 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,8 C7.26666667,8 6.66666667,7.4 6.66666667,6.66666667 C6.66666667,5.93333333 7.26666667,5.33333333 8,5.33333333 C8.73333333,5.33333333 9.33333333,5.93333333 9.33333333,6.66666667 C9.33333333,7.4 8.73333333,8 8,8 Z M12,6.8 C12,4.38 10.2333333,2.66666667 8,2.66666667 C5.76666667,2.66666667 4,4.38 4,6.8 C4,8.36 5.3,10.4266667 8,12.8933333 C10.7,10.4266667 12,8.36 12,6.8 Z M8,1.33333333 C10.8,1.33333333 13.3333333,3.48 13.3333333,6.8 C13.3333333,9.01333333 11.5533333,11.6333333 8,14.6666667 C4.44666667,11.6333333 2.66666667,9.01333333 2.66666667,6.8 C2.66666667,3.48 5.2,1.33333333 8,1.33333333 Z",
  id: "Shape",
  fill: "#0AA6A8",
  fillRule: "nonzero"
})))));

function SvgPlaceBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "295D9F7E-D37D-4E4A-B145-59D199FFF7DB@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceBlack24Dp);
export default __webpack_public_path__ + "static/media/place_black_24dp.25fa742c.svg";
export { ForwardRef as ReactComponent };